export default {
    studios: 
    [
        {
            spaceId: "sw8KjxrX14",
            typ:[
                {
                    name: "Privat",
                    slots: [
                        { 
                            hourVal: 2, 
                            text: "2 Stunden",
                            price: 120
                        },
                        { 
                            hourVal: 3, 
                            text: "3 Stunden",
                            price: 170
                        },
                        { 
                            hourVal: 4, 
                            text: "4 Stunden",
                            price: 220
                        },
                        { 
                            hourVal: 5, 
                            text: "5 Stunden",
                            price: 275
                        },
                        { 
                            hourVal: 6, 
                            text: "6 Stunden",
                            price: 330
                        },
                        { 
                            hourVal: 7, 
                            text: "7 Stunden",
                            price: 380
                        },
                        { 
                            hourVal: 8, 
                            text: "8 Stunden",
                            price: 430
                        },
                        { 
                            hourVal: 14, 
                            text: "1 Tag"
                        },
                        { 
                            hourVal: 38, 
                            text: "2 Tage"
                        },
                    ],
                    maxPersons: {
                        value: 6,
                        switchTo: "Gewerblich",
                        message: "Ab 6+ Personen wird auf gewerblich gestellt"
                    },
                    vat: true
                },
                {
                    name: "Gewerblich",
                    slots: [
                        { 
                            hourVal: 3, 
                            text: "3 Stunden",
                            price: 330
                        },
                        { 
                            hourVal: 5, 
                            text: "Halber Tag (5h)",
                            price: 500
                        },
                        { 
                            hourVal: 10, 
                            text: "Ganzer Tag (10h)",
                            price: 850
                        },
                        { 
                            hourVal: 14, 
                            text: "Full-Day (14h)",
                            price: 970
                        },
                        { 
                            hourVal: 38, 
                            text: "2 Tage",
                            price: 1940
                        },
                        { 
                            hourVal: 50, 
                            text: "3 Tage",
                            price: 2810
                        }
                    ],
                    persons: {
                        addCost: {
                            10: 50
                        }
                    },
                    vat: true
                }
            ]
        },
        {
            spaceId: "eDRA3WivNU",
            typ:[
                {
                    name: "Privat",
                    slots: [
                        { 
                            hourVal: 1, 
                            text: "1 Stunde",
                            price: 70
                        },
                        { 
                            hourVal: 2, 
                            text: "2 Stunden",
                            price: 120
                        },
                        { 
                            hourVal: 3, 
                            text: "3 Stunden",
                            price: 170
                        },
                        { 
                            hourVal: 4, 
                            text: "4 Stunden",
                            price: 220
                        },
                        { 
                            hourVal: 5, 
                            text: "5 Stunden",
                            price: 275
                        },
                        { 
                            hourVal: 6, 
                            text: "6 Stunden",
                            price: 330
                        },
                        { 
                            hourVal: 7, 
                            text: "7 Stunden",
                            price: 380
                        },
                        { 
                            hourVal: 8, 
                            text: "8 Stunden",
                            price: 430
                        },
                        { 
                            hourVal: 14, 
                            text: "1 Tag"
                        },
                        { 
                            hourVal: 38, 
                            text: "2 Tage"
                        },
                    ],
                    persons: {
                        max: 6
                    },
                    maxPersons: {
                        value: 6,
                        switchTo: "Gewerblich",
                        message: "Ab 6+ Personen wird auf gewerblich gestellt"
                    },
                    vat: true
                },
                {
                    name: "Gewerblich",
                    slots: [
                        { 
                            hourVal: 3, 
                            text: "3 Stunden",
                            price: 315
                        },
                        { 
                            hourVal: 5, 
                            text: "5 Stunden",
                            price: 450
                        },
                        { 
                            hourVal: 10, 
                            text: "10 Stunden",
                            price: 800
                        },
                        { 
                            hourVal: 14, 
                            text: "1 Tag",
                            price: 900
                        },
                        { 
                            hourVal: 38, 
                            text: "2 Tage",
                        },
                    ],
                    persons: {
                        addCost: {
                            10: 50
                        }
                    },
                    vat: true
                }
            ]
        }
    ]
    ,
    typ:[
        {
            name: "Privat",
            slots: [
                { 
                    hourVal: 2, 
                    text: "2 Stunden",
                    price: 120
                },
                { 
                    hourVal: 4, 
                    text: "4 Stunden",
                    price: 220
                },
                { 
                    hourVal: 8, 
                    text: "8 Stunden",
                    price: 400
                },
                { 
                    hourVal: 14, 
                    text: "1 Tag"
                },
                { 
                    hourVal: 38, 
                    text: "2 Tage"
                },
            ],
        },
        {
            name: "Gewerblich",
            slots: [
                { 
                    hourVal: 5, 
                    text: "Halber Tag"
                },
                { 
                    hourVal: 14, 
                    text: "1 Tag"
                },
                { 
                    hourVal: 38, 
                    text: "2 Tage",
                },
            ]
        }
    ],
    checkboxes: [
        { name: "acceptBooking", text: "Ich akzeptiere die <a href=\"https://brixxloftstudio.de/agb/\" target=\"_blank\">AGB</a> und die <a href=\"https://brixxloftstudio.de/datenschutz/\" target=\"_blank\">Datenschutzerklärung</a>." },
        { name: "acceptHouserules", text: "Ich akzeptiere die <a href=\"https://brixxloftstudio.de/hausregeln/\" target=\"_blank\">Hausregeln</a>" }
    ]
}